// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1Ai4-","colCheckbox":"styles_colCheckbox__2BtO9"};